/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DrugbankDrug
 */
export interface DrugbankDrug {
    /**
     * 
     * @type {string}
     * @memberof DrugbankDrug
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DrugbankDrug
     */
    drugbank_id?: string;
}

/**
 * Check if a given object implements the DrugbankDrug interface.
 */
export function instanceOfDrugbankDrug(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DrugbankDrugFromJSON(json: any): DrugbankDrug {
    return DrugbankDrugFromJSONTyped(json, false);
}

export function DrugbankDrugFromJSONTyped(json: any, ignoreDiscriminator: boolean): DrugbankDrug {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'drugbank_id': !exists(json, 'drugbank_id') ? undefined : json['drugbank_id'],
    };
}

export function DrugbankDrugToJSON(value?: DrugbankDrug | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'drugbank_id': value.drugbank_id,
    };
}

